// 答错后题目组件会被换 key 重新挂载(见 QuestPage 的 attemptSeq),组件内 state 会丢。
// 新题型用这个模块级小仓库记住"上次的作答草稿":
// 重新挂载且带着答错反馈时取回草稿,否则(新题/答对后)清掉。仅前端展示用。
const drafts = new Map();

export function takeDraft(puzzleId, feedback, fallback) {
  if (!feedback || feedback.correct) {
    drafts.delete(puzzleId);
    return fallback;
  }
  return drafts.has(puzzleId) ? drafts.get(puzzleId) : fallback;
}

export function saveDraft(puzzleId, value) {
  drafts.set(puzzleId, value);
}
